import * as THREE from "three";
let count = 0;
function randInt(min, max){
    if (max === undefined) {
        max = min;
        min = 0;
    }
    return Math.random() * (max - min) + min | 0;
}
const main = (renderCallback, name) => {
    const ctx = document.createElement('canvas').getContext('2d');
    ctx.canvas.width = 256;
    ctx.canvas.height = 256;
    ctx.fillStyle = '#FFF';
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    renderCallback.bind(renderCallback)

    const drawRandomDot = () => {
        ctx.fillStyle = `#${randInt(0x1000000).toString(16).padStart(6, '0')}`;
        ctx.beginPath();

        const x = randInt(256);
        const y = randInt(256);
        const radius = randInt(10, 64);
        ctx.arc(x, y, radius, 0, Math.PI * 2);
        ctx.fill();
    }

    let stopRender = false;

    const render = () => {
        if(stopRender) return;
        drawRandomDot();
        if(renderCallback){
            renderCallback(ctx);
        }
        requestAnimationFrame(render);
    }

    requestAnimationFrame(render);

    ctx.stopRender = ()=> stopRender = true;

    return ctx;
}


export function createDotsTexture(renderCallback){
    const ctx = main(renderCallback, count++)
    const texture = new THREE.CanvasTexture(ctx.canvas);
    texture.stopRender = ctx.stopRender;
    return texture;
}